module.exports = __webpack_public_path__ + "static/media/ServiceAMZ.2fadea0d.jpg";